import * as React from 'react'
import { getAssetUrl } from '../../../utils'

interface IArrowProps {
  direction: 'left' | 'right'
  className?: string
  style?: React.CSSProperties
  onClick?: React.ReactEventHandler
}

export const SliderArrow: React.FunctionComponent<IArrowProps> = (props: IArrowProps): React.ReactElement<HTMLDivElement> => {
  const { direction, className, style, onClick }: IArrowProps = props

  return (
    <div
      className={className}
      style={{ ...style, backgroundImage: `url(${getAssetUrl(`arrow-${direction}-light.svg`)})` }}
      onClick={onClick}
    />
  )
}
